import React, {useEffect, useState} from 'react';
import { Form, Input, DatePicker } from 'antd';
import SPSelectWithApi from "../../../../../../components/product-price/base/SPSelectWithApi";
import SPDynamicFormRender from "../../../../../../components/base/SPDynamicFormRender";
import moment from "moment/moment";
import {formatTimeRange} from "../../../../../../utils/tool";
const { TextArea } = Input;

interface IComponentProps {
  data?: any;
    enums?: any
}
const Remark: React.FC<IComponentProps> = (props) => {
  const data = props.data;
  const { enums } = props
  return (
    <>
        <Form.Item label={'订单编号'}>
            {data.order_code}
        </Form.Item>
        <Form.Item label={'取还时间'}>
            {`${formatTimeRange(data?.pickup_info?.time, data?.return_info?.time)}` }
        </Form.Item>
        <Form.Item name={'content'} label={'订单备注'} >
            <TextArea rows={4} showCount placeholder="请输入订单备注" maxLength={100} />
        </Form.Item>
    </>
  );
};

export default Remark;
